export enum AppEventsE {
  NEW_VERSION = 'new-version',
  MAINTENANCE_NOTIFICATION = 'maintenance-notification',
  GENERAL_NOTIFICATION = 'general-notification',
}
